/** @format */

import React from "react";
import Slider from "react-slick";
import Fade from "react-reveal/Fade";
import useSettings from "stores/settings";
import Link from "next/link";
import { observer } from "mobx-react-lite";

const AboutAISO = observer(() => {
  const setting = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const settings = useSettings();
  return (
    <div>
      <div className="w-full page-1-h">
        <div className="w-full h-full">
          <div className="first-page-content relative">
            <Fade bottom cascade>
              <div>
                <h1 className="w-full text-8xl font-gmarket-bold font-black text-white leading-loose mb-3">
                  나의 인공지능 서비스를 <br className="mo-hidden" />
                  개발하고 판매해 보세요!
                </h1>
                <h4 className="w-full text-3xl font-gmarket-medium font-bold text-white leading-loose mb-5">
                  판매된 서비스 앱의 수익을 한눈에 확인하세요!
                </h4>
                <div className="w-auto float-left">
                  {settings.login ? (
                    <Link href="/user/market">
                      <a className="ani-btn btn-home">
                        <span></span>
                        <i className="mdi mdi-arrow-right"></i>
                      </a>
                    </Link>
                  ) : (
                    <Link href="/signin">
                      <a className="ani-btn btn-home">
                        <span></span>
                        <i className="mdi mdi-arrow-right"></i>
                      </a>
                    </Link>
                  )}
                </div>
                <div className="w-auto absolute bottom-0 left-1/2 -ml-8">
                  <i className="icon-arrow-down font-bold text-xl text-white center p-4"></i>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      {/* 앱 제작소 장점 */}
      <div className="w-full h-full">
        <Fade bottom cascade>
          <div className="page-content py-20">
            <Fade bottom cascade>
              <div className="md:flex md:justify-center md:items-center rounded-visitor-market mt-14 mb-28 rounded-visitor-market aiso_glass_in_bg">
                <div className="w-full md:w-1/2 p-2">
                  <div className="img-cover-box">
                    <img src="/images/visitor/dev_01.png" alt="" />
                  </div>
                </div>
                <div className="w-full md:w-1/2 p-5 keep-words">
                  <h2 className="text-333 font-gmarket-bold pt-28 pb-4">내 서비스 앱을 효율적으로 관리해 보세요.</h2>
                  <h4 className="text-555 font-gmarket-medium leading-8 pb-5">
                    문의, 신고, 랭킹 등 내 서비스 앱의 정보를 한눈에 관리 할 수 있습니다!
                  </h4>
                </div>
              </div>
            </Fade>
            <Fade bottom cascade>
              <div className="md:flex md:justify-center md:items-center rounded-visitor-market mt-28 mb-28 rounded-visitor-market aiso_glass_in_bg">
                <div className="w-full md:w-1/2 p-5">
                  <div className="img-cover-box">
                    <img src="/images/visitor/dev_03.png" alt="" />
                  </div>
                </div>
                <div className="w-full md:w-1/2 p-5 keep-words">
                  <h2 className="text-333 font-gmarket-bold pt-28 pb-4">나만의 서비스 앱을 제작해 거래해 보세요!</h2>
                  <h4 className="text-555 font-gmarket-medium leading-8 pb-5">
                    코드 또는 URL로 쉬운 앱 제작이 가능합니다! 개발자가 아닌 사용자도 마켓에 거래되고 있는 앱 들을 조합해 클릭만으로 새로운
                    앱 제작이 가능합니다!
                  </h4>
                </div>
              </div>
            </Fade>
            {/* TODO : 데이터분석 앱 내용이라서 뺐음, 문현정 나중에 AISO DATA 로 보내기 */}
            {/* <Fade bottom cascade>
              <div className="md:flex md:justify-center md:items-center rounded-visitor-market mt-28 mb-28 rounded-visitor-market aiso_glass_in_bg">
                <div className="w-full md:w-1/2 p-5">
                  <div className="img-cover-box">
                    <img src="/images/visitor/dev_02.png" alt="" />
                  </div>
                </div>
                <div className="w-full md:w-1/2 p-5 keep-words">
                  <h2 className="text-333 font-gmarket-bold pt-28 pb-4">데이터 파일로 분석 앱을 제작해 보세요!</h2>
                  <h4 className="text-555 font-gmarket-medium leading-8 pb-5">
                    분석할 데이터 파일 만으로 서비스 앱 제작이 가능합니다! 나의 분석된 데이터를 앱으로 제작하여 거래해 보세요!
                  </h4>
                </div>
              </div>
            </Fade> */}
          </div>
        </Fade>
      </div>
      {/* 앱 제작소 사용 설명 */}
      <div className="w-full h-full bg-white">
        <div className="page-content pt-20 pb-60">
          {/* 타이틀 */}
          <Fade bottom cascade>
            <div className="keep-words">
              <div>
                <h3 className="text-888 font-gmarket-medium font-bold pt-28 pb-4">
                  <i className="fa fa-question-circle mr-3 text-primary" />
                  인공지능 서비스 앱은 어떻게 제작하나요?
                </h3>
                <h1 className="text-333 font-gmarket-bold pb-1">인공지능 서비스 앱 제작방법</h1>
                <p className="text-333 font-gmarket-medium pb-5 text-xl">코드로 앱 제작, URl로 앱 제작, 앱+앱으로 새로운 앱 제작</p>
              </div>
            </div>
          </Fade>
          {/* 슬라이더영역 */}
          <Fade bottom cascade>
            <div className="mt-14 mb-32">
              <Slider {...setting} className="p-0 m-0 visitor-slider">
                <div className="w-full">
                  <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                    <div className="w-full md:w-1/2">
                      <div className="img-cover-box">
                        <img src="/images/visitor/make-1-1-1.png" alt="" />
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                      <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">
                        01-<span className="text-4xl">1</span>
                      </h1>
                      <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                        코드로 앱 제작! <br />: 코드 입력
                      </p>
                      <p className="text-555 text-lg font-gmarket-medium">
                        소스코드 입력 만으로 서비스 앱 제작이 가능합니다. 소스코드가 없을시 하단의 샘플 코드를 사용합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                    <div className="w-full md:w-1/2">
                      <div className="img-cover-box">
                        <img src="/images/visitor/make-1-2.png" alt="" />
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                      <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">
                        01-<span className="text-4xl">2</span>
                      </h1>
                      <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                        URL 앱 제작 <br />: URL 입력
                      </p>
                      <p className="text-555 text-lg font-gmarket-medium">URL을 입력 후 헤더에 요청할 키값 과 파라미터를 입력합니다.</p>
                      <p className="text-888 text-lg font-gmarket-medium">
                        <i className="mdi mdi-alert-circle"></i> 단, 확장자 명이 같아야 결합이 가능합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                    <div className="w-full md:w-1/2">
                      <div className="img-cover-box">
                        <img src="/images/visitor/make-1-3.png" alt="" />
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                      <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">
                        01-<span className="text-4xl">3</span>
                      </h1>
                      <p className="text-333 text-2xl font-gmarket-medium font-bold tracking-widest pb-3">
                        커스텀 앱 제작
                        <br />: 앱+앱 = New 앱
                      </p>
                      <p className="text-555 text-lg font-gmarket-medium">합칠 앱 들을 Drag and Drop 후 파라미터를 조정합니다.</p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market mb-5">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/make-1-1-2.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5"></h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                  코드로 앱 제작 <br />: 파일 추가
                </p>
                <p className="text-555 text-lg font-gmarket-medium">
                  학습된 모델, 설정파일, 이미지, 텍스트 파일 등 코드와 함께 실행될 파일들을 추가합니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/make-2.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">02</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">프리뷰 설정</p>
                <p className="text-555 text-lg font-gmarket-medium">
                  앱실행에 필요한 input 파일을 추가하고 실행 결과의 파일 확장자를 선택합니다. 프리뷰를 실행하여 미리 확인이 가능합니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>

          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/make-3.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">03</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">앱 설명 및 라이센스 작성</p>
                <p className="text-555 text-lg font-gmarket-medium">앱에 관한 디테일한 설명을 작성하고, 라이센스를 표시합니다.</p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/make-4.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">04</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">앱 기본정보 입력</p>
                <p className="text-555 text-lg font-gmarket-medium">앱에 관한 디테일한 설명을 작성하고, 라이센스를 표시합니다.</p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/make-5.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">05</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">나의 서비스 앱을 마켓에 등록하여 거래해 보세요!</p>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      {/* 데이터 분석 설명 */}
      {/* <div className="w-full h-full bg-white">
        <div className="page-content py-20">
          <Fade bottom cascade>
            <div className="keep-words">
              <div>
                <h3 className="text-888 font-gmarket-medium font-bold pt-28 pb-4">
                  <i className="fa fa-question-circle mr-3 text-primary" />
                  데이터 분석 앱은 어떻게 제작하나요?
                </h3>
                <h1 className="text-333 font-gmarket-bold pb-1">데이터 분석 앱 제작방법 </h1>
                <p className="text-333 font-gmarket-medium pb-5 text-xl">Csv 파일 데이터 분석</p>
              </div>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market mb-5">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_make-1.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">01</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">나의 데이터 분석 목록</p>
                <p className="text-555 text-lg font-gmarket-medium">
                  데이터 분석 목록중 앱으로 제작하고 싶은 분석 데이터를 선택하여 제작하거나 새로운 데이터를 추가하여 분석한다.
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market mb-5">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_make-2.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">02</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">데이터 파일을 업로드</p>
                <p className="text-555 text-lg font-gmarket-medium">
                  분석할 데이터 파일 (csv 파일)을 업로드 한 후 타겟을 설정해 줍니다. 데이터 파일이 없을시 아래 샘플 데이터 파일을 사용해
                  보세요.
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="mt-14 mb-32">
              <Slider {...setting} className="p-0 m-0 visitor-slider">
                <div className="w-full">
                  <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                    <div className="w-full md:w-1/2">
                      <div className="img-cover-box">
                        <img src="/images/visitor/data_make-3-1.png" alt="" />
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                      <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">
                        03-<span className="text-4xl">1</span>
                      </h1>
                      <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                        나의 데이터 분석 결과 확인 <br />: 데이터 분석
                      </p>
                      <p className="text-555 text-lg font-gmarket-medium">나의 분석된 데이터 결과를 확인하고 앱을 제작합니다.</p>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                    <div className="w-full md:w-1/2">
                      <div className="img-cover-box">
                        <img src="/images/visitor/data_make-3-2.png" alt="" />
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                      <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">
                        03-<span className="text-4xl">2</span>
                      </h1>
                      <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                        나의 데이터 분석 결과 확인
                        <br />: 알고리즘
                      </p>
                      <p className="text-555 text-lg font-gmarket-medium">분석된 데이터의 알고리즘을 확인하고 앱을 제작합니다.</p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_make-4.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">04</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                  데이터 분석 앱 제작 <br />: 컬럼 설명
                </p>
                <p className="text-555 text-lg font-gmarket-medium">
                  각 컬럼에 대한 설명을 작성합니다. 다음 제작 단계는 서비스앱 제작과 동일하며 같은 방법으로 작성합니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>

          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_make-5.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">05</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                  나의 데이터 분석 앱을 데이터 분석에 등록하여 거래해 보세요!
                </p>
              </div>
            </div>
          </Fade>
        </div>
      </div> */}
      <div className="center py-20 keep-words bg-indigo-100">
        <h1 className="text-000 font-gmarket-medium font-bold tracking-widest pb-3">
          나의 인공지능 서비스 앱을 제작하여 수익을 창출해 보세요!
        </h1>
        <p className="text-333 text-lg font-gmarket-medium mb-5">
          내가 찾던 인공지능 서비스와 유사한 서비스를 제작한 개발자에게 의뢰를 문의해보세요.
        </p>
        {settings.login ? (
          <Link href="/dev/myApp">
            <button type="" className="btn glass_in_btn text-base font-gmarket-medium">
              인공지능 앱 제작하러 가기
              <i className="mdi mdi-arrow-right ml-2"></i>
            </button>
          </Link>
        ) : (
          <Link href="/signin">
            <button type="" className="btn glass_in_btn text-base font-gmarket-medium">
              인공지능 앱 제작하러 가기
              <i className="mdi mdi-arrow-right ml-2"></i>
            </button>
          </Link>
        )}
      </div>
    </div>
  );
});

export default AboutAISO;
